import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  BrowserRouter,
  Redirect,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import GetPageData from "../hooks/GetPageData";
import NavAndFooter from "../GramPages/Common/NavAndFooterContainer/index";
import LoadingComponet from "../components/Loading/LoadingComponet";

import HomePage from "../GramPages/Home";
import AchievementPage from "../GramPages/AchievementPage";

import AboutUs from "../GramPages/AboutUs";
import PanchayatPeople from "../GramPages/PanchayatPeople";
import GalleryPage from "../GramPages/Gallery";
import InfoPage from "../GramPages/InfoPage";
import ModalContainer from "../ModalLayouts/ModalContainer";
import { useSelector } from "react-redux";

import GramSchemes from "../Pages/GramSchemes";
import FormsPage from "../Pages/Forms/index";
// import GalleryPage from "../Pages/Gallery/index";
// import ContactUs from "../Pages/Contactus";
// import Suggetions from "../Pages/Suggetions";
// import GramHome from "../Pages/GramHome";
// import ModalContainer from "../ModalLayouts/ModalContainer";
import TermsPage from "../Pages/TermsAndConditions";
import CopyRights from "../Pages/CopyRights";

import EgramSchemes from "../GramPages/eGramSchemes";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";

const useStyles = makeStyles((theme) => ({
  root: {
    // [theme.breakpoints.down("md")]: {
    //   backgroundColor: "white",
    // },
  },
}));

const GramRoutes = (props) => {
  const classes = useStyles();
  const gramId = useSelector((state) => state.util.currentGramId);
  const { ready, data, error } = GetPageData(`gramNavbar/${gramId}`);

  const ScrollToTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    return null;
  };
  const location = useLocation();
  ReactGA.pageview(`${props?.gram || "gram"}${location.pathname}`);

  return ready && data ? (
    <NavAndFooter data={data}>
      <Helmet>
        <title>{`${props?.gram || "E-"} Gram Panchayat`}</title>
        <meta
          name="description"
          content={`Welcome to ${props.gram} gram panchayat`}
        />
        <meta property="og:title" content={`${props.gram} gram panchayat`} />
        <meta
          property="og:url"
          content={`https://${props.gram}.egrampanchayat.in`}
        />
        <meta
          property="og:description"
          content={`${props.gram} gram panchayat website`}
        />
        <meta
          property="og:image"
          itemprop="image"
          content="https://egrampanchayat.in/images/otherlogos/selfmade.png"
        />
        <meta
          property="og:image:secure_url"
          itemprop="image"
          content="https://egrampanchayat.in/images/otherlogos/selfmade.png"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_IN" />
      </Helmet>

      <Route component={ScrollToTop} />
      <Switch>
        <Route
          exact
          path="/"
          render={(props) => <HomePage gram={props.gram} />}
        />
        <Route exact path="/aboutus" component={AboutUs} />

        <Route exact path="/panchayatmember" component={PanchayatPeople} />
        <Route exact path="/gallery" component={GalleryPage} />
        {/* <Switch> */}
        <Route exact path="/info/:type" component={InfoPage} />
        <Route exact path="/achievement/:id" component={AchievementPage} />
        {/* </Switch> */}

        <Route exact path="/egramservices" component={EgramSchemes} />

        <Route
          exact
          path="/gramschemes/:schemeCategory?"
          component={GramSchemes}
        />
        <Route exact path="/forms" component={FormsPage} />
        <Route exact path="/termsandconditions" component={TermsPage} />
        <Route exact path="/copyrights" component={CopyRights} />
        {/* <Route exact path="/panchayatshabhya" component={AboutUs} />
      <Route exact path="/gramschemes" component={GramSchemes} />
      <Route exact path="/forms" component={FormsPage} />
      <Route exact path="/gallery" component={GalleryPage} />
      <Route exact path="/termsandconditions" component={TermsPage} /> */}

        {/* <Route exact path="/contactus" component={ContactUs} /> */}
        {/* <Route exact path="/suggestions" component={Suggetions} /> */}

        <Redirect to="/" />
      </Switch>

      <ModalContainer />
    </NavAndFooter>
  ) : (
    <div>
      <LoadingComponet />
    </div>
  );
};
export default GramRoutes;
